function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#ffcab2}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Path_537",
  fill: "#fff",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44 49.5H6C2.967 49.5.5 47.033.5 44V6C.5 2.967 2.967.5 6 .5h38c3.033 0 5.5 2.467 5.5 5.5v38c0 3.033-2.467 5.5-5.5 5.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeaea",
  d: "M6 1C3.243 1 1 3.243 1 6v38c0 2.757 2.243 5 5 5h38c2.757 0 5-2.243 5-5V6c0-2.757-2.243-5-5-5H6m0-1h38c3.314 0 6 2.686 6 6v38c0 3.314-2.686 6-6 6H6c-3.314 0-6-2.686-6-6V6c0-3.314 2.686-6 6-6z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "flow",
  transform: "translate(7 7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_778",
  fill: "#4d4d4f",
  d: "M23154.658 17107.367v-3.164h-11.605a1.045 1.045 0 0 1-1.053-1.053v-4.221a1.055 1.055 0 0 1 2.109 0v3.162h23.2v-3.162a1.056 1.056 0 0 1 2.111 0v4.221a1.045 1.045 0 0 1-1.053 1.053h-11.605v3.164a1.053 1.053 0 1 1-2.105 0zm12.652-12.654v-3.168h-7.123a1.053 1.053 0 1 1 0-2.105h8.182a1.052 1.052 0 0 1 1.053 1.053v4.221a1.056 1.056 0 0 1-2.111 0zm-25.311 0v-4.221a1.052 1.052 0 0 1 1.053-1.053h8.186a1.053 1.053 0 0 1 0 2.105h-7.129v3.168a1.055 1.055 0 0 1-2.109 0zm12.658-8.693v-3.965a1.053 1.053 0 0 1 2.105 0v3.965a1.053 1.053 0 0 1-2.105 0z",
  transform: "translate(-23137.711 -17076.711)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_771",
  d: "M190.492 0h-8.437A1.044 1.044 0 0 0 181 1.055v4.289a1.044 1.044 0 0 0 1.055 1.056h8.438a1.044 1.044 0 0 0 1.055-1.055v-4.29A1.044 1.044 0 0 0 190.492 0z",
  className: "cls-3",
  transform: "translate(-168.273)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_772",
  d: "M190.492 421h-8.437a1.044 1.044 0 0 0-1.055 1.055v4.289a1.044 1.044 0 0 0 1.055 1.055h8.438a1.044 1.044 0 0 0 1.055-1.055v-4.289a1.044 1.044 0 0 0-1.056-1.055z",
  className: "cls-3",
  transform: "translate(-168.273 -391.398)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_773",
  d: "M370.563 247.328h-8.508a1.054 1.054 0 0 1-1.055-1.055v-4.219a1.054 1.054 0 0 1 1.055-1.054h8.508a1.054 1.054 0 0 1 1.055 1.055v4.219a1.054 1.054 0 0 1-1.055 1.054z",
  className: "cls-3",
  transform: "translate(-335.617 -224.055)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_774",
  d: "M9.563 247.328H1.055A1.054 1.054 0 0 1 0 246.273v-4.219A1.054 1.054 0 0 1 1.055 241h8.508a1.054 1.054 0 0 1 1.055 1.055v4.219a1.054 1.054 0 0 1-1.055 1.054z",
  className: "cls-3",
  transform: "translate(0 -224.055)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_775",
  fill: "#f26524",
  d: "M188.089 122.189L183.6 117.7a1.07 1.07 0 0 0-1.476 0l-4.493 4.493a1.057 1.057 0 0 0 0 1.477l4.493 4.493a1.07 1.07 0 0 0 1.476 0l4.493-4.493a1.057 1.057 0 0 0-.004-1.481z",
  transform: "translate(-164.858 -109.146)"
}));

function SvgColorIconsProcedure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "color-icons_procedure",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconsProcedure);
export default __webpack_public_path__ + "static/media/color-icons_procedure.ad4d7787.svg";
export { ForwardRef as ReactComponent };